import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';

import CustomModal from '../../Components/Components/Modal';

import {
  claimChestBonus,
  claimAdventBonus,
  claimGiftLink,
  closeEmailVerifyBonusModal,
} from '../../../../../actions/member';
import * as constants from '../../../../../constants/constants';
import { Media } from 'reactstrap';
import davana from '../../../../../images/Menu/davana.svg';
import davana1000 from '../../../../../images/Menu/davana_1000.svg';

class BonusModals extends React.PureComponent {
    static propTypes = {
      showChestBonusModal: PropTypes.bool,
      showAdventBonusModal: PropTypes.bool,
      showGiftLinkModal: PropTypes.bool,
      showEmailVerifyBonusModal: PropTypes.bool,
      t: PropTypes.func.isRequired,
      claimChestBonusFunc: PropTypes.func.isRequired,
      claimAdventBonusFunc: PropTypes.func.isRequired,
      claimGiftLinkFunc: PropTypes.func.isRequired,
      closeEmailVerifyBonus: PropTypes.func.isRequired,
      newVersion: PropTypes.string,
      holidayModalOpen: PropTypes.bool,
      toggleBonusModal: PropTypes.func.isRequired,
      openModal: PropTypes.bool,
      holidayTest: PropTypes.bool,
      selectedTestHoliday: PropTypes.shape({}),
      cancelHolidayTest: PropTypes.func.isRequired,
    }

    static defaultProps = {
      showChestBonusModal: false,
      showAdventBonusModal: false,
      showGiftLinkModal: false,
      showEmailVerifyBonusModal: false,
      newVersion: '',
      holidayModalOpen: false,
      openModal: false,
    }

    componentDidUpdate(prevProps) {
      const { showChestBonusModal, showAdventBonusModal, toggleBonusModal, showGiftLinkModal } = this.props;

      if ((!prevProps.showChestBonusModal && showChestBonusModal) || (!prevProps.showAdventBonusModal && showAdventBonusModal) || (!prevProps.showGiftLinkModal && showGiftLinkModal)) {
        toggleBonusModal(true);
      }
    }

    claimChestBonusFuncA = () => {
      const { claimChestBonusFunc, toggleBonusModal } = this.props;
      claimChestBonusFunc();
      toggleBonusModal(false);
    }

    claimAdventBonusFuncA = () => {
      const { claimAdventBonusFunc, toggleBonusModal } = this.props;
      claimAdventBonusFunc();
      toggleBonusModal(false);
    }

    claimTestAdventBonusFuncA = () => {
      const { claimAdventBonusFunc, toggleBonusModal, cancelHolidayTest } = this.props;
      cancelHolidayTest();
      claimAdventBonusFunc();
      toggleBonusModal(false);
    }

  claimGiftLinkFuncA = () => {
    const { claimGiftLinkFunc, toggleBonusModal } = this.props;
    claimGiftLinkFunc();
    toggleBonusModal(false);
  }

    render() {
      const {
        showChestBonusModal,
        showAdventBonusModal,
        showGiftLinkModal,
        t,
      //  claimChestBonusFunc,
      //  claimAdventBonusFunc,
        newVersion,
        openModal,
        holidayModalOpen,
        showEmailVerifyBonusModal,
        closeEmailVerifyBonus,
        holidayTest,
        selectedTestHoliday,
      } = this.props;

      console.log('Bonus modals', showEmailVerifyBonusModal);

      if (holidayTest) {
        if (selectedTestHoliday?.id === constants.ADVENT_BONUS_MODAL) {
          return (
            <CustomModal
              isOpen
              className="new-version-modal"
              toggle={this.claimTestAdventBonusFuncA}
              size="lg"
              title={t('common:common.congratulations')}
              body={(
                <div className="holiday-modal-content">
                  {t('claimAdventBonus')}
                  <Media src={davana1000} className="holiday-modal-img" />
                </div>
              )}
              footer={(
                <Button color="link" className="notification-footer-button" onClick={() => this.claimTestAdventBonusFuncA()}>{t('thanks')}</Button>
              )}
            />
          );
        }
      }

      if (newVersion && newVersion >= constants.NEW_VERSION && !openModal && !holidayModalOpen) {
        if (showChestBonusModal) {
          return (
            <CustomModal
              isOpen
              className="new-version-modal"
              toggle={this.claimChestBonusFuncA}
              size="lg"
              title={t('common:common.congratulations')}
              body={(
                <div className="holiday-modal-content">
                  {t('claimChestBonus')}
                </div>
              )}
              footer={(
                <Button color="link" className="notification-footer-button" onClick={() => this.claimChestBonusFuncA()}>{t('thanks')}</Button>
              )}
            />
          );
        }
        if (showAdventBonusModal) {
          return (
            <CustomModal
              isOpen
              className="new-version-modal"
              toggle={this.claimAdventBonusFuncA}
              size="lg"
              title={t('common:common.congratulations')}
              body={(
                <div className="holiday-modal-content">
                  {t('claimAdventBonus')}
                  <Media src={davana1000} className="holiday-modal-img" />
                </div>
              )}
              footer={(
                <Button color="link" className="notification-footer-button" onClick={() => this.claimAdventBonusFuncA()}>{t('thanks')}</Button>
              )}
            />
          );
        }
        if (showGiftLinkModal) {
          return (
            <CustomModal
              isOpen
              className="new-version-modal"
              toggle={this.claimGiftLinkFuncA}
              size="lg"
              title={t('common:common.congratulations')}
              body={(
                <div className="holiday-modal-content">
                  {t('claimGiftLink')}
                  <Media src={davana1000} className="holiday-modal-img" />
                </div>
              )}
              footer={(
                <Button color="link" className="notification-footer-button" onClick={() => this.claimGiftLinkFuncA()}>{t('thanks')}</Button>
              )}
            />
          );
        }
      }
      if (!openModal && !holidayModalOpen && showEmailVerifyBonusModal) {
        return (
          <CustomModal
            isOpen={showEmailVerifyBonusModal}
            toggle={closeEmailVerifyBonus}
            size="md"
            verticalCentering
            largeText
            title={t('common:common.congratulations')}
            footer={(
              <Button className="modal-footer-button tutorial-result-button mb-3" color="secondary" onClick={closeEmailVerifyBonus}>
                {t('common:common.ok')}
              </Button>
            )}
            body={(
              <>
                {t('updateProfile:earnedReward')}
              </>
            )}
          />
        );
      }
      return null;
    }
}

const mapStateToProps = state => ({
  showChestBonusModal: state.member.showChestBonusModal || false,
  showAdventBonusModal: state.member.showAdventBonusModal || false,
  showGiftLinkModal: state.member.showGiftLinkModal || false,
  showEmailVerifyBonusModal: state.member.showEmailVerifyBonusModal || false,
  newVersion: state.member.newVersion || null,
});

const mapDispatchToProps = {
  claimChestBonusFunc: claimChestBonus,
  claimAdventBonusFunc: claimAdventBonus,
  claimGiftLinkFunc: claimGiftLink,
  closeEmailVerifyBonus: closeEmailVerifyBonusModal,
};


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(['holiday', 'updateProfile', 'common'])(BonusModals));
